import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Logo from '../../assets/icons/efrs_logo.svg';
import { Icon } from 'antd';
import { DarkSkyBlue, SunYellow, WhiteFour } from '../../styles/Colours';
import MenuComponent from '../../components/Menu/MenuComponent';
import ImageComponent from '../../components/Images/ImageComponent';
import LoginModal from '../../components/Login/LoginModal';
import { BodyScroll } from '../../components/Utils';
import { device } from '../../styles/Responsive';

const MobileBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: ${DarkSkyBlue};
  display: none;

  @media ${device.tablet} {
    display: block;
    z-index: 95;
  }
`;

const LogoSection = styled.div`
  height: 100px;
  cursor: pointer;
  position: fixed;
  width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 99;
  background: ${WhiteFour};

  img {
    display: inline-block;
    height: 100px;
  }

  @media ${device.laptop} {
    width: 220px;
  }

  @media ${device.tablet} {
    height: 60px;
    width: auto;
    img {
      margin: 0 10px;
      height: 60px;
    }
  }
`;

const LoginSection = styled.div`
  position: fixed;
  top: 0;
  right: 150px;
  z-index: 99;
  width: 150px;
  height: 100px;
  background: ${DarkSkyBlue};
  color: ${WhiteFour};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  svg {
    width: 30px;
    height: 30px;
    margin-left: 18px;
  }

  @media ${device.tablet} {
    height: 60px;
    color: ${WhiteFour};
    width: 80px;
    right: 80px;
    span {
      display: none;
    }
    svg {
      margin-left: 0;
    }
  }
`;

const MenuSection = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background: ${SunYellow};
  color: ${DarkSkyBlue};
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  svg {
    width: 30px;
    height: 30px;
    margin-left: 18px;
  }

  @media ${device.tablet} {
    height: 60px;
    background: ${DarkSkyBlue};
    color: ${WhiteFour};
    width: 80px;
    span {
      display: none;
    }
    svg {
      margin-left: 0;
    }
  }
`;

const Photo = styled.div`
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  margin-left: 18px;
`;

const getFirstName = name => {
  let spacePosition = name.indexOf(' ');
  if (spacePosition === -1) return name;
  else if(spacePosition > 10) return name.substr(0, 10)+"...";
  else return name.substr(0, spacePosition);
  
};

class HeaderComponent extends React.Component {
  state = {
    openLogin: false,
    openMenu: false
  };

  renderProfile = () => {
    const { user, history } = this.props;
    if (user && user.id) {
      return (
        <LoginSection onClick={() => history.push('/wall')}>
          <span>{getFirstName(user.profile.name)}</span>
          <Photo>
            <ImageComponent image={user.profile.photo} ratio={1} width="100%" />
          </Photo>
        </LoginSection>
      );
    }
    return (
      <LoginSection
        onClick={() =>
          this.setState({ openLogin: true }, () => BodyScroll(true))
        }
      >
        <span>Login</span>
        <Icon type="user" theme="outlined" />
      </LoginSection>
    );
  };

  render() {
    const { openLogin, openMenu } = this.state;
    const { history } = this.props;
    return (
      <React.Fragment>
        <MobileBar />
        <LogoSection onClick={() => history.push('/')}>
          <img src={Logo} alt="EFRS" />
        </LogoSection>
        <MenuSection
          onClick={() =>
            this.setState({ openMenu: true }, () => BodyScroll(true))
          }
        >
          <span>Menu</span>
          <Icon type="menu-fold" theme="outlined" />
        </MenuSection>
        {this.renderProfile()}
        <MenuComponent
          show={openMenu}
          onClose={() =>
            this.setState({ openMenu: false }, () => BodyScroll(false))
          }
        />
        <LoginModal
          show={openLogin}
          onClose={() =>
            this.setState({ openLogin: false }, () => BodyScroll(false))
          }
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

HeaderComponent = connect(mapStateToProps)(HeaderComponent);

export default withRouter(HeaderComponent);



// WEBPACK FOOTER //
// ./src/pages/layout/HeaderComponent.js